<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import AuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue'

defineProps({
    policy: String,
})
</script>

<template>
    <AppLayout meta_title="Privacy Policy">
        <template #content>
            <div class="text-zinc-100 antialiased">
                <div class="bg-zinc-100 pt-4 pb-10 dark:bg-zinc-900">
                    <div class="flex min-h-screen flex-col items-center pt-6 sm:pt-0">
                        <div>
                            <AuthenticationCardLogo />
                        </div>

                        <div
                            class="markdown-content prose dark:prose-invert mt-6 w-full overflow-hidden bg-white/5 p-6 shadow-md ring-1 ring-white/10 sm:max-w-2xl sm:rounded-3xl sm:p-8"
                            v-html="policy"
                        />
                    </div>
                </div>
            </div>
        </template>
    </AppLayout>
</template>
